import React,{Component} from 'react';
import {reduxForm} from 'redux-form';
import * as actions from '../../actions';
import { Link, browserHistory} from 'react-router';
import $ from 'jquery';
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';
class Signup extends Component{
 constructor(props){
    super(props);
    this.state={
      mobile: localStorage.mobile_number,
      err_email: '',
      err_tnc: '',
      ref_status:false,
    }
  }
  componentWillMount(){
    this.props.clear_state();
  }
  componentDidMount() {
    // Load reCAPTCHA script
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.async = true;
    script.defer = true;
    script.onload = () => this.setState({ recaptchaLoaded: true });
    document.body.appendChild(script);
  }
  handleFormSubmit(formProps)
  {
    var mobile = localStorage.getItem('mobile_number');
    var data1={from:'mobile_web',mobile: mobile,name: formProps.name,password: formProps.password,email: formProps.email,referral: formProps.refcode,device: '',version: '',platform: '',device_id:localStorage.getItem('push_device_id') }; 
    var data2 = JSON.stringify(data1);
    //this.props.Signup(formProps);
    var flag=0;  
    const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
    const namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
    if(formProps.name && !namePattern.test(formProps.name)){
      $('#name_err').text('Enter minimum 3 characters');
      flag = 1;
    }
    if(formProps.password.length < 4){
      $('#pwd_err').text('Minmum 4 characters');
      flag = 1;    
    }
    if(formProps.email && !emailPattern.test(formProps.email)){
      $('#email_err').text('Enter a valid email');
      flag= 1;
    }
    if(!formProps.tnc){
      $('#tnc_err').text('Please accept Terms and conditions');
      flag = 1;
    }
    const recaptchaResponse = document.getElementById('g-recaptcha-response').value;;

    if (!recaptchaResponse) {
      $('#captcha_err').text('Please complete the reCAPTCHA');
      flag = 1;
    }  
  if(flag === 0){
      var button = $('.mob_signup_btn');
      button.html("loading...");  
      button.prop("disabled",true);
        $.ajax({
            method: 'POST',
            url: baseUrl+'signup',
            dataType:'json',
            data: {req:data2},
            success: function(data){
              button.prop("disabled",false);
              button.html("creating account");
              if(data.status === 'referror'){
              $("#ref_err").text(data.message); 
              }
              if(data.status === 'error'){
              $("#email_err").text(data.message);
              }
              if(data.status === 'success'){
                localStorage.setItem('pwd',data.pwd);
                browserHistory.push('/Otpverify');
                //window.location.reload();
              }
          },
          error: function(err){
          button.prop("disabled",false);
          button.html("create account");          
          // console.log("Error"+err);
        }
        });    
  }
    // this.state={
    //     mobile: localStorage.mobile_number,
    // }
  }
  

  // componentWillReceiveProps(newProps) {
  //     if (newProps.formdata.status === 'referror') {
  //         this.setState({
  //             err_ref: newProps.formdata.message,
  //         }); 
  //     }
  //     if(newProps.formdata.status === 'error'){
  //         this.setState({
  //           err_email: newProps.formdata.message,
  //         });
  //     }
  //     if (newProps.formdata.status === 'success') {
  //         localStorage.setItem('pwd',newProps.formdata.pwd);
  //         // browserHistory.push('/verify');
  //     }
  // }

  render(){
  $('#ref_input').keyup(function() {
            $('#ref_err').text('');
  });
  $('#email_input').keyup(function() {
            $('#email_err').text('');
  });  
  $('#name_input').keyup(function() {
            $('#name_err').text('');
  });
  $('#pwd_input').keyup(function() {
            $('#pwd_err').text('');
  });
  $('#tnc_input').click(function() {
            $('#tnc_err').text('');
  });      
  $(document).on('click', '#recaptcha-anchor', function() {
      $('#captcha_err').text('');
  });
    document.title ="AquaDeals SignUp - You find,buy best deals by sign up with us";
    document.getElementsByTagName("META")[2].content="You find,buy best deals by sign up with us";
    const {handleSubmit,fields:{name,password,email,refcode,tnc}} = this.props;
    return (
          <div>
             <div className="user_form">
                <Link to={'/login'} className="back_icon"><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt="" /></i></Link>
                  <div className="container pag_cntnt">
                    <div className="row" style={{marginLeft:'0',marginRight:'0'}}>
                      <h5 className="sign_in_title">Sign Up</h5>
                        <form className="text-center Regist_form" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))} name="login">  
                           <div className="reg_group"> 
                              <label><span>+91</span></label>
                              <input type="text"  ref="mobile" value={this.state.mobile}  required/>
                              <span className="highlight"></span>
                              <span className="bar"></span>
                           </div>
                           <div className="clr">&nbsp;</div>
                            <div className="reg_group">      
                                <input type="text" placeholder="Name" id="name_input" required {...name} ref="name" />
                                <span className="highlight"></span>
                                <span className="bar"></span>
                                <span id='name_err'></span>  
                            </div>
                            <div className="clr">&nbsp;</div>
                            <div className="reg_group">      
                                <input type="password" placeholder="Password" required {...password} id='pwd_input' ref="pwd" />
                                <span className="highlight"></span>
                                <span className="bar"></span>
                                <span id="pwd_err"></span>
                            </div>
                            <div className="clr">&nbsp;</div>
                            <div className="reg_group">      
                                <input placeholder="Email (optional)" type="text" {...email} ref="email" id="email_input"  />
                                <span className="highlight"></span>
                                <span id="email_err"></span>
                            </div>
                            <div className="clr">&nbsp;</div>
                            <div className="ref_code">
                                <a onClick={()=>{this.setState({ref_status: true})}} >Have a referral code?</a>
                            </div>
                            <div className="clr">&nbsp;</div>
                           {this.state.ref_status ? <div className="group form_fields signup_ref_field">      
                                <input type="text" placeholder="Referral Code(Optional)" id="ref_input" {...refcode} ref="refer" />
                                <span className="highlight"></span>
                                <span className="bar"></span>
                                <span id="ref_err"></span>
                            </div> : ''}
                            
                            <div className="row">
                                <div className="terms_check">
                                     <input type="checkbox" value="checked"  {...tnc} ref="tnc" id="tnc_input"/>
                                     <span className="terms_signup_note">I accept & agree </span><a target="_blank" href="https://aqua.deals/terms.html">Terms of Services</a>
                                     <div id='tnc_err'></div>
                                </div>
                            </div>
                            <p className="verify_desc">Your mobile number will be verified using an OTP</p>
                            <div className="recaptcha-mobile">
                            <div className="g-recaptcha" data-sitekey="6LeoplwUAAAAAIoBTSeogNosrRo_uRpFmJh-e3fr" data-size="compact"></div>            
                            <div id='captcha_err'></div>
                            </div>   
                            <div style={{marginTop:'15px'}}>
                                <button action="submit" className="btn mob_regbtn">SIGN UP</button>
                            </div>
                       </form>
                    </div>
                  </div> 
               </div>
           </div>

        );
     }
  }
 function mapStateToProps(state){
    return {
      errorMessage:state.auth.error,
      authenticated:state.auth.authenticated,
      formdata:state.auth.formdata
    };
 }
  export default reduxForm({
    form :'Otpverify',
    fields:['name','password','email','refcode','tnc'],
  },mapStateToProps,actions)(Signup);



/** WEBPACK FOOTER **
 ** ./src/components/Auth/Signup.js
 **/